/**
 * Sayfa durumunu sıfırlar (başka sayfadan geliş senaryoları için)
 * @param {boolean} keepFilter - Filtre durumunu korumak için true gönderin (opsiyonel)
 */
export const resetPageState = function(keepFilter = false) {
  // Sadece state'i sıfırla, önbellekleri temizleme
  this.currentPage = 1
  this.sortKey = ''
  this.sortOrder = 'DESC'
  this.searchQuery = ''

  // Filtreyi sadece istenirse sıfırla
  if (!keepFilter) {
    this.selectedFilter = 1 // "Hepsi" filtresi
  }

  if (process.env.VUE_APP_MODE === 'development') {
    console.log('Sayfa durumu sıfırlandı (cache temizleme olmadan)', { keepFilter })
  }
}

/**
 * URL'deki query parametrelerinden sayfa durumunu ayarlar
 * @param {Object} query - Route query parametreleri
 */
export const setStateFromQuery = function(query) {
  if (query.page) {
    this.currentPage = parseInt(query.page) || 1
  }

  if (query.sortKey) {
    this.sortKey = query.sortKey
  }

  if (query.sortOrder) {
    this.sortOrder = ['ASC', 'DESC'].includes(query.sortOrder) ? query.sortOrder : 'DESC'
  }

  if (query.q) {
    this.searchQuery = query.q
  }

  if (query.filter) {
    this.selectedFilter = parseInt(query.filter) || 1
  }

  if (process.env.VUE_APP_MODE === 'development') {
    console.log('Sayfa durumu URL\'den yüklendi:', {
      page: this.currentPage,
      sortKey: this.sortKey,
      sortOrder: this.sortOrder,
      q: this.searchQuery,
      filter: this.selectedFilter,
    })
  }
}

/**
 * Mevcut sayfa durumunu URL query parametrelerine dönüştürür
 * @returns {Object} - Query parametreleri objesi
 */
export const getQueryFromState = function() {
  const query = {}

  // Varsayılan olmayan değerler için URL parametresi ekle
  if (this.currentPage > 1) {
    query.page = this.currentPage
  }

  if (this.sortKey) {
    query.sortKey = this.sortKey
    query.sortOrder = this.sortOrder || 'DESC'
  }

  if (this.searchQuery) {
    query.q = this.searchQuery
  }

  if (this.selectedFilter !== null && this.selectedFilter !== 1) { // 1 = "Hepsi" filtresi
    query.filter = this.selectedFilter
  }

  return query
}

/**
 * Mevcut durum değerlerini URL query'sine ekler
 * @param {Object} router - Vue Router nesnesi
 * @param {Object} additionalQuery - Eklenecek diğer query parametreleri
 */
export const syncStateWithUrl = function(router, additionalQuery = {}) {
  // Sadece tab parametresini al ve koru
  const tab = router.currentRoute.value.query.tab

  // Yeni query sadece tab içermeli
  const newQuery = tab ? { tab } : {}

  // URL'i güncelle - sadece farklıysa, gereksiz history girişlerinden kaçınmak için
  if (JSON.stringify(router.currentRoute.value.query) !== JSON.stringify(newQuery)) {
    router.push({ query: newQuery })
  }

  if (process.env.VUE_APP_MODE === 'development') {
    console.log('URL temizlendi, sadece tab parametresi korundu')
  }
}

/**
 * İçerik detay sayfasına yönlendirir
 * @param {Object} router - Vue Router nesnesi
 * @param {string} contentId - İçerik ID'si
 */
export const showContentDetail = function(router, contentId) {
  // İçerik ID'sini store'a kaydet
  this.setSelectedContentId(contentId)

  // Görünüm değişiyor, detay moduna geçiliyor
  this.lastActiveView = 'detail'

  // URL parametrelerini değiştirmeden sadece store durumunu güncelle
}

/**
 * İçerik listesine geri döner
 * @param {Object} router - Vue Router nesnesi
 */
export const hideContentDetail = function(router) {
  // Store'daki içerik ID'sini temizle
  this.selectedContentId = null

  // Görünüm değişiyor, liste moduna geçiliyor
  this.lastActiveView = 'list'

  // view parametresini kaldır
  const routeQuery = router.currentRoute.value.query
  const { view, ...otherQuery } = routeQuery

  // Route'u güncelleyerek view parametresini kaldır
  router.push({ query: otherQuery })
}

/**
 * Asset ID durumunu günceller ve değişiklik olup olmadığını kontrol eder
 * @param {string} assetId - Yeni asset ID
 * @returns {boolean} - Asset ID değişti mi
 */
export const updateAssetId = function(assetId) {
  // İlk kez ayarlanıyorsa
  if (!this.previousAssetId) {
    this.previousAssetId = assetId
    return false
  }
  
  // Değişip değişmediğini kontrol et
  const hasChanged = this.previousAssetId !== assetId
  
  // Geliştirme modunda log'la
  if (hasChanged && process.env.VUE_APP_MODE === 'development') {
    console.log('Asset ID değişikliği tespit edildi', {
      previous: this.previousAssetId,
      current: assetId,
    })
  }
  
  // Yeni asset ID'yi kaydet
  this.previousAssetId = assetId
  
  return hasChanged
}

/**
 * Asset değişikliğini kontrol eder
 * @param {string} currentAssetId - Mevcut asset ID
 * @returns {boolean} - Asset değişti mi?
 */
export const hasAssetChanged = function(currentAssetId) {
  // Eğer previousAssetId yoksa (ilk kez kontrol ediliyor) false döndür
  if (!this.previousAssetId) {
    return false
  }
  
  return this.previousAssetId !== currentAssetId
}